import BaseService from './BaseService'

const ApiService = {
    fetchData(param) {
        return new Promise((resolve, reject) => {
            BaseService(param)
                .then((response) => {
                    resolve(response)
                })
                .catch((errors) => {
                    reject(errors)
                })
        })
    },

    uploadFormData(payload) {
        return new Promise((resolve, reject) => {
            const { url, method = 'post', data } = payload

            if (!url || !data) {
                return reject(new Error('URL and data are required in payload'))
            }

            BaseService({
                url,
                method: method.toLowerCase(),
                data,
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
                .then((response) => resolve(response))
                .catch((error) => reject(error))
        })
    },

    fetchDataWithManualRedirect(param) {
        return new Promise((resolve, reject) => {
            BaseService({
                ...param,
                maxRedirects: 0, // Prevent automatic redirects
                validateStatus: function (status) {
                    // Accept all status codes including redirects
                    return status >= 200 && status < 400
                }
            })
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => {
                    // Handle redirect responses that axios treats as errors
                    if (error.response && (error.response.status === 302 || error.response.status === 301)) {
                        resolve(error.response)
                    } else {
                        reject(error)
                    }
                })
        })
    },
}

export default ApiService
